import React from 'react'
import { useDrop } from 'react-dnd'
import { useSelector } from 'react-redux'
import NumberFormat from 'react-number-format'
import { carouselCurrentItemSelector } from '../../selectors'
import DragIcon from 'custom/assets/transfers/drag.svg'
import '../../styles/BeneficiaryTransfers.css'

export default function BeneficiaryDropTarget() {
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: 'BeneficiaryGridItem',
    drop: () => ({ name: 'Transfer Drop Target' }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })

  const isActive = canDrop && isOver

  let opacity = 1

  if (isActive) {
    opacity = 0.5
  } else if (canDrop) {
    opacity = 1
  }

  return (
    <div ref={drop} className='drop-target' style={{ opacity }}>
      <div className=''>
        <p className=''>Drag Beneficiary to make Payment</p>

        <div className='drop-img'></div>
        <div className='balance-section'>
          <p>Available Balance</p>
          <h5>
            <NumberFormat
              className='balance'
              value={currentAccountDetail?.avlBal}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />

            <span className='font-weight-500' style={{ marginLeft: 5 }}>
              {currentAccountDetail?.currency}
            </span>
          </h5>
        </div>
      </div>
    </div>
  )
}
